import { css } from '@emotion/react'
import React from 'react'
import {
  ConditionName,
  Option,
  OptionSetType,
  PeriodParams,
  RangeParams,
} from '../../actions'
import { Conditions } from '../../constants/conditions'
import { Errors } from '../../reducers/error'
import { ConditionItem } from './ConditionItem'

export type BaseProps = {
  onToggle: (cond: ConditionName) => void
  onRemove: (cond: ConditionName) => void
  onSelectOption: (cond: ConditionName, option: Option) => void
  onSelectOptionList: (
    cond: ConditionName,
    options: Option[],
    setType: OptionSetType
  ) => void
  onSelectPeriod: (cond: ConditionName, period: PeriodParams) => void
  onSelectRange: (cond: ConditionName, range: RangeParams) => void
  opening: ConditionName | null
  errors: Errors
}

type ListProps = {
  conditions: Conditions
} & BaseProps

const ConditionList = ({ conditions, ...props }: ListProps) => (
  <ul
    className="condition-list"
    css={css`
      display: contents;
    `}
  >
    {Object.keys(conditions)
      // @ts-ignore
      .map((n) => [n, conditions[n]])
      .map(([name, selected], i) => {
        const key = `${i}-${name}`
        return (
          <ConditionItem key={key} name={name} selected={selected} {...props} />
        )
      })}
  </ul>
)

export default ConditionList
